import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList } from "vue"
import _imports_0 from '@/assets/illustrations/autopilot.svg'


const _hoisted_1 = { class: "mx-4 mt-2 mpc-cluster-config" }
const _hoisted_2 = { class: "bar full-width pa-2" }
const _hoisted_3 = {
  key: 0,
  class: "token-text-medium ml-2 my-auto"
}
const _hoisted_4 = { class: "token-text-medium ml-2 my-auto" }
const _hoisted_5 = { class: "token-text-medium" }
const _hoisted_6 = { class: "mx-2" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = {
  key: 0,
  class: "token-text-regular my-auto token-text-color-secondary d-flex ml-2"
}
const _hoisted_9 = {
  key: 0,
  class: "token-text-regular token-text-color-secondary"
}
const _hoisted_10 = { class: "token-text-regularbold" }
const _hoisted_11 = { class: "my-auto full-width" }
const _hoisted_12 = { class: "token-text-mediumbold" }
const _hoisted_13 = { class: "mx-auto token-text-pico" }
const _hoisted_14 = { class: "mx-auto token-text-mediumbold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_RadioListElement = _resolveComponent("RadioListElement")!
  const _component_HeightDeployer = _resolveComponent("HeightDeployer")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_CustomNumberInput = _resolveComponent("CustomNumberInput")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Slider = _resolveComponent("Slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_row, {
        class: "ma-0 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.accountPickerOpen = !_ctx.accountPickerOpen), ["stop"]))
      }, {
        default: _withCtx(() => [
          (_ctx.accountPickerOpen)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Select an account "))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_ctx.hasAnyAccountOption)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_Icon, {
                        icon: "block",
                        class: "ml-2 mr-0"
                      }),
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "token-text-medium ml-2 my-auto" }, " No account selected ", -1))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.currentProviderAccount)
                        ? (_openBlock(), _createBlock(_component_Logo, {
                            key: 0,
                            logo: _ctx.currentProviderAccount?.provider,
                            class: "ml-2 mr-0"
                          }, null, 8, ["logo"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentProviderAccount?.name || "Select an account"), 1)
                    ], 64))
              ], 64)),
          _createVNode(_component_CustomButton, {
            class: "ml-auto my-auto",
            level: _ctx.$enums.ButtonLevels.SmallIcon
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                icon: "caret-down",
                class: _normalizeClass(["caret", { invert: _ctx.accountPickerOpen }])
              }, null, 8, ["class"])
            ]),
            _: 1
          }, 8, ["level"])
        ]),
        _: 1
      }),
      _createVNode(_component_HeightDeployer, {
        modelValue: _ctx.accountPickerOpen,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.accountPickerOpen) = $event)),
        class: "ma-2"
      }, {
        default: _withCtx(() => [
          (!_ctx.hasAnyAccountOption)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "ma-0 mt-2 token-text-regular"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" You need to connect a " + _toDisplayString(_ctx.providerLabel) + " account to continue ", 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.hasFransysAccount)
                  ? (_openBlock(), _createBlock(_component_RadioListElement, {
                      key: 0,
                      selected: _ctx.selectedInfrastructureProviderAccountId === null,
                      class: "mt-2",
                      onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCustomerAccount(null)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Logo, {
                          logo: "fransys",
                          class: "mr-2 ml-0"
                        }),
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "token-text-medium my-auto" }, "Fransys account", -1))
                      ]),
                      _: 1
                    }, 8, ["selected"]))
                  : _createCommentVNode("", true),
                (_ctx.customerAccounts.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_v_row, {
                        class: _normalizeClass(["ma-0 token-text-regular token-text-color-secondary", { 'mt-4': _ctx.hasFransysAccount }])
                      }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode(" Use your own account ")
                        ])),
                        _: 1
                      }, 8, ["class"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerAccounts, (account) => {
                        return (_openBlock(), _createBlock(_component_RadioListElement, {
                          key: account.id,
                          selected: _ctx.selectedInfrastructureProviderAccountId === account.id,
                          class: "mt-2",
                          onSelect: ($event: any) => (_ctx.selectCustomerAccount(account.id))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Logo, {
                              logo: account.provider,
                              class: "mr-2 ml-0"
                            }, null, 8, ["logo"]),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(account.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["selected", "onSelect"]))
                      }), 128))
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64)),
          _createVNode(_component_v_row, {
            class: "ma-0 mt-4 token-text-medium token-text-color-secondary account-link",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('connectAccount')))
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode(" Connect another account ")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_v_row, { class: "ma-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "pa-0 d-flex" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "ma-0 my-2 mx-auto fit-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass('token-text-medium' + (!_ctx.internalIsAutoPilot ? 'bold' : ''))
                }, " Manual ", 2),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Switch, {
                    modelValue: _ctx.internalIsAutoPilot,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.internalIsAutoPilot) = $event)),
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:isAutoPilot', _ctx.internalIsAutoPilot)))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass('token-text-medium' + (_ctx.internalIsAutoPilot ? 'bold' : ''))
                }, " AutoPilot ", 2)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.internalIsAutoPilot && !_ctx.nodePoolList.length)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "ma-0 mb-2 card"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "pa-0 mr-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "ma-0 bg-gradiant-autopilot rounded-border token-text-regular pa-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "pa-0 d-flex-col" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: _imports_0,
                          height: "40px",
                          width: "40px",
                          class: "mx-auto my-2"
                        }),
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "mx-auto" }, "Autopilot mode activated", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "ma-0 pa-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "pa-0 my-auto token-text-regular" }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode(" Monthly maximum budget ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { class: "pa-0 my-auto" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CustomNumberInput, {
                          modelValue: _ctx.internalMaxBudget,
                          "onUpdate:modelValue": [
                            _cache[6] || (_cache[6] = ($event: any) => ((_ctx.internalMaxBudget) = $event)),
                            _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update:maxBudget', $event)))
                          ],
                          min: _ctx.minBudget
                        }, null, 8, ["modelValue", "min"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { class: "pa-0 fit-content ml-2 my-auto token-text-regular" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$enums.CurrencyTrigramToSymbol[_ctx.currency]), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_ctx.nodePoolList.length)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      class: "ma-0 pa-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Message, {
                          severity: _ctx.$enums.Severity.INFO
                        }, {
                          title: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createTextVNode(" Your cluster is ready ")
                          ])),
                          text: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createTextVNode(" Your cluster is already fully configured, and you can deploy it as is."),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" You can specify which typologies of node you want to use by adding node pools."),
                            _createElementVNode("br", null, null, -1)
                          ])),
                          _: 1
                        }, 8, ["severity"]),
                        _createVNode(_component_CustomButton, {
                          level: _ctx.$enums.ButtonLevels.Secondary,
                          icon: "edit",
                          text: "Edit node pool",
                          class: "mt-2 full-width",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('goToAddNodePool')))
                        }, null, 8, ["level"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.errorMsg)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 1,
          class: "ma-0 mt-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Message, {
              title: "Not enought nodes",
              severity: _ctx.$enums.Severity.DANGER,
              text: _ctx.errorMsg
            }, null, 8, ["severity", "text"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.nodePoolList.length || !_ctx.internalIsAutoPilot)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 2,
          class: "ma-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "ma-0 mb-2" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[23] || (_cache[23] = _createElementVNode("span", { class: "token-text-h5" }, " Node pools ", -1)),
                      (_ctx.internalIsAutoPilot)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.nbMasterNodes.min > 0 || _ctx.nbMasterNodes.max > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                  _createTextVNode(" + " + _toDisplayString(_ctx.nbMasterNodes.min) + " ", 1),
                                  (_ctx.nbMasterNodes.min !== _ctx.nbMasterNodes.max)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_Icon, {
                                          icon: "arrow-right",
                                          class: "mx-2"
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.nbMasterNodes.max), 1)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _cache[22] || (_cache[22] = _createTextVNode(" master nodes ")),
                                  _createVNode(_component_Tooltip, {
                                    class: "ml-1",
                                    docLink: "guides/cluster-configuration/#defining-the-number-of-nodes"
                                  }, {
                                    header: _withCtx(() => _cache[20] || (_cache[20] = [
                                      _createTextVNode(" Control nodes are added ")
                                    ])),
                                    content: _withCtx(() => _cache[21] || (_cache[21] = [
                                      _createTextVNode(" Starting at 2 nodes, we add dedicated nodes to manage the workload on your cluster."),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" They are added to improve reliability and stability and while fully managed by Fransys, they increase the overall cost of your cluster. ")
                                    ])),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.nbMasterNodes.min > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_9, " + " + _toDisplayString(_ctx.nbMasterNodes.min) + " master nodes ", 1))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]),
                    _createVNode(_component_CustomButton, {
                      class: "ml-auto my-auto",
                      level: _ctx.$enums.ButtonLevels.SmallIcon,
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.nodePoolDeployed = !_ctx.nodePoolDeployed))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Icon, {
                          icon: "caret-down",
                          class: _normalizeClass(["caret", { invert: _ctx.nodePoolDeployed }])
                        }, null, 8, ["class"])
                      ]),
                      _: 1
                    }, 8, ["level"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "ma-0 mx-n4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_HeightDeployer, {
                      modelValue: _ctx.nodePoolDeployed,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.nodePoolDeployed) = $event)),
                      class: "full-width"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "pa-0" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodePoolList, (nodePool, index) => {
                              return (_openBlock(), _createBlock(_component_v_row, {
                                key: 'node-pool-' + index,
                                class: "ma-0 mx-4 card-typo pa-2 mb-2"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                    _ctx.getFullTypologie(nodePool.typology),
                  ], (fullTypologie, index2) => {
                                    return (_openBlock(), _createBlock(_component_v_col, {
                                      key: 'fullTypologie-' + index + '-' + index2,
                                      class: "fit-content"
                                    }, {
                                      default: _withCtx(() => [
                                        fullTypologie
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createVNode(_component_v_row, { class: "ma-0 token-text-color-primary token-text-redular" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(fullTypologie?.attributes.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_row, { class: "ma-0 token-text-color-primary token-text-redular" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$helpers.prices.format(
                            Number(fullTypologie?.attributes.price.amount),
                            fullTypologie?.attributes.price.currency,
                          )), 1),
                                                  _cache[24] || (_cache[24] = _createElementVNode("span", { class: "ml-1" }, " / node ", -1))
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_row, { class: "ma-0 token-text-color-primary token-text-redular" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { class: "pa-0 fit-content mr-2" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_row, { class: "ma-0" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(fullTypologie?.attributes.cores) + " ", 1),
                                                          _createVNode(_component_Icon, {
                                                            icon: "chip",
                                                            class: "ml-1"
                                                          })
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, { class: "pa-0 fit-content mr-2" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_row, { class: "ma-0" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(fullTypologie?.attributes.memory) + " ", 1),
                                                          _createVNode(_component_Icon, {
                                                            icon: "ram",
                                                            class: "ml-1"
                                                          })
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, { class: "pa-0 fit-content" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_row, { class: "ma-0" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(fullTypologie?.attributes.gpus.length) + " ", 1),
                                                          _createVNode(_component_Icon, {
                                                            icon: "gpu",
                                                            class: "ml-1"
                                                          })
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128)),
                                  _createVNode(_component_v_col, { class: "pa-0 d-flex" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_11, [
                                        (!_ctx.internalIsAutoPilot)
                                          ? (_openBlock(), _createBlock(_component_Slider, {
                                              key: 0,
                                              value: nodePool.target_size,
                                              step: 1,
                                              min: 0,
                                              max: _ctx.nbMaxNodePerPool,
                                              range: false,
                                              "onUpdateValue:value": ($event: any) => (_ctx.updateNodePoolSize(nodePool, $event))
                                            }, {
                                              "thumb-label": _withCtx(({ modelValue }) => [
                                                _createElementVNode("span", _hoisted_12, _toDisplayString(modelValue), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["value", "max", "onUpdateValue:value"]))
                                          : (_openBlock(), _createBlock(_component_Slider, {
                                              key: 1,
                                              values: [nodePool.min_size, nodePool.max_size],
                                              step: 1,
                                              min: 0,
                                              max: _ctx.nbMaxNodePerPool,
                                              range: true,
                                              class: "pt-12",
                                              "onUpdateValue:values": ($event: any) => (
                        _ctx.updateNodePoolSize(nodePool, $event[0], $event[1])
                      )
                                            }, {
                                              "thumb-label": _withCtx(({ modelValue }) => [
                                                _createVNode(_component_v_col, { class: "pa-0 d-flex-col px-1" }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", _hoisted_13, _toDisplayString(modelValue === nodePool.min_size ? "Min" : "Max"), 1),
                                                    _createElementVNode("span", _hoisted_14, _toDisplayString(modelValue), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["values", "max", "onUpdateValue:values"]))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, { class: "pa-0 d-flex fit-content" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_CustomButton, {
                                        class: "ml-auto my-auto",
                                        level: _ctx.$enums.ButtonLevels.SmallIcon,
                                        icon: "trash",
                                        iconColor: "#E15F19",
                                        onClick: ($event: any) => (_ctx.$emit('deleteNodePool', index))
                                      }, null, 8, ["level", "onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128)),
                            _createVNode(_component_v_row, { class: "ma-0 token-background-color-secondary mx-n4 mt-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CustomButton, {
                                  level: _ctx.$enums.ButtonLevels.Secondary,
                                  icon: "add",
                                  text: "Add node pool",
                                  class: "my-2 ml-8",
                                  style: { width: 'calc(100% - 64px)' },
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('goToAddNodePool')))
                                }, null, 8, ["level"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}